import { value, onMounted, onBeforeDestroy } from 'vue-function-api'

export const windowSize = () => {
  const height = value(window.innerHeight)
  const width = value(window.innerWidth)

  const handleResize = () => {
    height.value = window.innerHeight
    width.value = window.innerWidth
  }

  onMounted(() => window.addEventListener('resize', handleResize))
  onBeforeDestroy(() => window.removeEventListener('resize', handleResize))

  return {
    height,
    width
  }
}
